import { render, staticRenderFns } from "./MatTing.vue?vue&type=template&id=e8e474ce&scoped=true"
import script from "./MatTing.vue?vue&type=script&lang=js"
export * from "./MatTing.vue?vue&type=script&lang=js"
import style0 from "./MatTing.vue?vue&type=style&index=0&id=e8e474ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e474ce",
  null
  
)

export default component.exports